import { encode } from 'uqr';

type QrCodeProps = { value: string; label: string; size?: number };

/** One path through the dark cells: `M x y h1 v1 h-1 z` for each. */
export const qrPath = (value: string) => {
  const { data } = encode(value, { border: 2 });
  const cells: string[] = [];
  data.forEach((row, y) => {
    row.forEach((dark, x) => {
      if (dark) cells.push(`M${x} ${y}h1v1h-1z`);
    });
  });
  return { path: cells.join(''), size: data.length };
};

/**
 * A QR code for a link, drawn from uqr's grid rather than its SVG string, so no generated
 * markup is ever injected. Dark on white in both themes: scanners need that contrast.
 */
export const QrCode = ({ value, label, size = 160 }: QrCodeProps) => {
  const { path, size: cells } = qrPath(value);
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${cells} ${cells}`}
      shapeRendering="crispEdges"
      className="rounded-md"
    >
      <rect width={cells} height={cells} fill="#ffffff" />
      <path d={path} fill="#000000" />
    </svg>
  );
};
